import { useEffect } from 'react';
import { useAction } from '../hooks'; 

const useRequestAddress = (prefix, region_id, province_id, municipality_id, barangay_id) => {

  const getRegion = useAction('region.view', { prefix })
  const setListRegion = useAction('region.setList', { prefix })
  
  const getProvince = useAction('province.view', { prefix })
  const setListProvince = useAction('province.setList', { prefix })

  const getMunicipality = useAction('municipality.view', { prefix })
  const setListMunicipality = useAction('municipality.setList', { prefix })

  const getBarangay = useAction('barangay.view', { prefix })
  const setListBarangay = useAction('barangay.setList', { prefix })

  useEffect(() => {

    if(region_id)
      getRegion(prefix, region_id)

    if(province_id)  
      getProvince(prefix, province_id)
    
    if(municipality_id)
      getMunicipality(prefix, municipality_id)
    
    if(barangay_id)
      getBarangay(prefix, barangay_id)

    return () => {
      setListRegion({ prefix, regions: {} })
      setListProvince(({ prefix, provinces: {} }))
      setListMunicipality({ prefix, municipalities: {} })
      setListBarangay({ prefix, barangays: {} })
    }
     // eslint-disable-next-line
  }, [region_id, province_id, municipality_id, barangay_id])


  
}

export default useRequestAddress;